import { Heading, Text } from '@components/ui/typography'
import { parse } from '@config/theme'
import { decodeAssetId } from '@lib/sanity/decode-asset-id'
import { urlFor } from '@lib/sanity/url-for'
import Image from 'next/image'
import NextLink from 'next/link'
import React, { FC } from 'react'
import { BlogItem } from '__generated__/sanity'
import { parseDate } from './parse-date'
import { BlogTag, BlogTags } from './Tags'

export const BlogCard: FC<BlogItem['fields']> = ({ preview, summary }) => {
  if (!preview || !preview.image || !summary) return null

  const { dimensions } = decodeAssetId(preview.image.asset._ref)
  return (
    <NextLink
      href={`/blog/${summary.urlSlug.current}`}
      className={container}
      title={summary.summaryTitle}
    >
      <Image
        src={urlFor(preview.image)
          .width(dimensions.width * 0.75)
          .toString()}
        layout="responsive"
        alt=""
        width={dimensions.width * 0.75}
        height={dimensions.height * 0.75}
        data-image=""
      />
      <Text variant="bodyLarge" fontWeight="bold" color="shade500" mt={{ _: '6' }} mb="2">
        {parseDate(summary.date)}
      </Text>
      <Heading as="h2" variant="h5" mb="4">
        {summary.summaryTitle}
      </Heading>
      {summary.tags && summary.tags.length && (
        <BlogTags>
          {summary.tags.map((tag) => (
            <BlogTag key={tag}>{tag}</BlogTag>
          ))}
        </BlogTags>
      )}
      <Text variant="bodyRegular" color="purpleWeb">
        Read post
      </Text>
    </NextLink>
  )
}

const container = parse({ mb: { _: '48', sm: '64' } })
